import React, { useState } from 'react';
import ContactHero from '../Images/contact.jpg';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', website: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', phone: '', website: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
    setLoading(false);
  };

  return (
    <main>
      {/* Contact Info */}
      <section
        className="bg-[#f4f7f0] py-32 sm:py-40 px-4 sm:px-6 overflow-hidden"
        data-navbar-light="true"
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-12 items-start">
          <div>
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#1e3019] mb-1 sm:mb-2">Contact</h1>
            <p className="font-body text-[#1e3019]/40 text-xl sm:text-2xl mb-8 sm:mb-12">Our HQ is in Ontario, Canada</p>
            <div className="mb-6 sm:mb-8">
              <p className="font-body text-[#1e3019]/40 text-xs uppercase tracking-widest mb-2">Email Address</p>
              <a href="mailto:hello@carbonetics.ca"
                className="font-body text-[#1e3019] text-lg sm:text-xl font-medium hover:opacity-70 transition-opacity">
                hello@carbonetics.ca
              </a>
            </div>
            <div>
              <p className="font-body text-[#1e3019]/40 text-xs uppercase tracking-widest mb-2">Address</p>
              <p className="font-body text-[#1e3019] text-lg sm:text-xl font-medium leading-relaxed">
                503-7700 Hurontario Street<br />
                Brampton, ON L6Y 4M3<br />
                Canada
              </p>
            </div>
          </div>

          {/* Image — flush to right edge */}
          <div className="relative h-96 sm:h-[500px] -mr-4 sm:-mr-6 overflow-hidden rounded-l-2xl">
            <img
              src={ContactHero}
              alt="Contact"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="bg-[#e8ede4] py-16 sm:py-24 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#1e3019] mb-3 sm:mb-4">Let's Talk Impact</h2>
          <p className="font-body text-[#1e3019]/60 text-sm sm:text-base mb-8 sm:mb-12">
            Have questions or ideas? Reach out. We're here to help you turn sustainability into strategy.
          </p>

          {status === 'success' && (
            <div className="mb-6 sm:mb-8 p-4 bg-green-100 border border-green-200 rounded-xl font-body text-green-800 text-sm">
              ✓ Your message has been sent! We'll be in touch soon.
            </div>
          )}
          {status === 'error' && (
            <div className="mb-6 sm:mb-8 p-4 bg-red-100 border border-red-200 rounded-xl font-body text-red-800 text-sm">
              Something went wrong. Please try again or email us directly.
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-6 sm:gap-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
              {[
                { name: 'name', placeholder: 'Your Name', type: 'text', required: true },
                { name: 'email', placeholder: 'Email Address', type: 'email', required: true },
                { name: 'phone', placeholder: 'Contact number', type: 'tel', required: false },
                { name: 'website', placeholder: 'Website', type: 'text', required: false },
              ].map((field) => (
                <input key={field.name}
                  type={field.type}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={form[field.name]}
                  onChange={handleChange}
                  required={field.required}
                  className="bg-transparent border-b border-[#1e3019]/20 focus:border-[#1e3019] outline-none font-body text-[#1e3019] text-sm sm:text-base py-3 placeholder-[#1e3019]/30 transition-colors w-full"
                />
              ))}
            </div>
            <textarea
              name="message"
              placeholder="Message"
              value={form.message}
              onChange={handleChange}
              required
              rows={6}
              className="w-full bg-transparent border-b border-[#1e3019]/20 focus:border-[#1e3019] outline-none font-body text-[#1e3019] text-sm sm:text-base py-3 placeholder-[#1e3019]/30 transition-colors resize-none"
            />
            <div>
              <button type="submit" disabled={loading}
                className="inline-flex items-center gap-2 border border-[#1e3019] text-[#1e3019] font-body px-6 sm:px-8 py-3 sm:py-3.5 rounded-full hover:bg-[#1e3019] hover:text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base">
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}